import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function OutlinedFlagIcon(props: IconProps) {
    return <Icon {...props} iconKey={"outlined_flag"}/>
}
